import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const SidebarContext = createContext(null);
const STORAGE_KEY = 'flowdoc:sidebar-collapsed';
export function SidebarProvider({ children }) {
    const [collapsed, setCollapsedState] = useState(() => {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    });
    const toggle = useCallback(() => {
        setCollapsedState(prev => {
            const next = !prev;
            localStorage.setItem(STORAGE_KEY, String(next));
            return next;
        });
    }, []);
    const setCollapsed = useCallback((value) => {
        localStorage.setItem(STORAGE_KEY, String(value));
        setCollapsedState(value);
    }, []);
    const value = useMemo(() => ({ collapsed, toggle, setCollapsed }), [collapsed, toggle, setCollapsed]);
    return _jsx(SidebarContext.Provider, { value: value, children: children });
}
export function useSidebar() {
    const ctx = useContext(SidebarContext);
    if (!ctx)
        throw new Error('useSidebar must be used within SidebarProvider');
    return ctx;
}
